import { useEffect, useState } from "react";
import {
	Col,
	Container,
	OverlayTrigger,
	Row,
	Spinner,
	Tab,
	Tabs,
	Tooltip,
} from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { HiOutlineArrowCircleLeft } from "react-icons/hi";
import { useHistory, useParams } from "react-router-dom";
import { IUserAccount } from "../../../../models/IUserAccount";
import { managerProfileDetails } from "../../../../services/profile.service";
import { ContentHeader } from "../../styled";
import { CardAccessDetail } from "./components/card-access-detail";
import { CardAccountDetail } from "./components/card-account-detail";
import { CardCompanyDetail } from "./components/card-company-detail";
import { CardSignatureDetail } from "./components/card-signature-detail";
import { UserMaterials } from "./components/user-materials";
import { ContentBody } from "./styled";

const DEFAULT_VALUE = {
	id: 0,
	name: "",
	company: "",
	job: "",
	phone: "",
	email: "",
	picture: "",
	signature: "",
	username: "",
	status: "",
	created_at: "",
	deleted_at: "",
	updated_at: "",
	is_superuser: false,
	is_staff: false,
	is_active: false,
	is_whatsapp: false,
	is_signature: false,
};

/**
 *
 * Detalhes do usuário da DStore
 *
 * Usuarios -> Todos usuários -> Visualizar perfil
 * ou
 * Usuários -> Todos usuários -> Materiais utilizados
 *
 * Detalhes da conta, como nome, e-mail e epresa
 * Lista de materiais utilizados pelo usuário
 */
export const UserDetail = (): JSX.Element => {
	const { t: translation } = useTranslation();
	const history = useHistory();
	const { id } = useParams<{ id: string }>();
	const queryParams = new URLSearchParams(window.location.search);
	const materialTab = queryParams.get("materialTab");
	const listKey = queryParams.get("key");

	const [loading, setLoading] = useState(false);
	const [userType, setUserType] = useState("");
	const [user, setUser] = useState<IUserAccount>(DEFAULT_VALUE);
	const [key, setKey] = useState<string>(
		materialTab ? "materials" : "details"
	);

	useEffect(() => {
		getUser();
		window.scrollTo(0, 0);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleBack = () => {
		if (listKey) {
			history.push(`/manager/users?key=${listKey}`);
		} else {
			history.goBack();
		}
	};

	const getUser = () => {
		setLoading(true);
		managerProfileDetails(Number(id))
			.then((response: any) => {
				setUserType(response.status);
				setUser(response);
				setLoading(false);
			})
			.finally(() => {
				setLoading(false);
			});
	};

	return (
		<Container fluid>
			{loading ? (
				<div className="loading-container mt-5">
					<Spinner
						animation="border"
						variant="primary"
					/>
				</div>
			) : (
				<div id="tabs-materials">
					{/* Cabeçalho - Nome do usuário e voltar */}
					<ContentHeader>
						<Row>
							<Col>
								<OverlayTrigger
									placement="top"
									overlay={
										<Tooltip>{translation("back")}</Tooltip>
									}
								>
									<span>
										<HiOutlineArrowCircleLeft
											size={24}
											style={{
												marginRight: "10px",
												marginTop: "-10px",
												cursor: "pointer",
											}}
											className="mr-1 mb-1 cursor-pointer"
											onClick={() => handleBack()}
										/>
									</span>
								</OverlayTrigger>
								<span className="title">{user.name}</span>
							</Col>
						</Row>
					</ContentHeader>

					{/*  Abas -> Detalhes da conta | Materiais utilizados */}
					<Tabs
						className="tabs mb-3 mt-4"
						activeKey={key}
						onSelect={(k: any) => setKey(k)}
					>
						{/* Detalhes da Conta */}
						<Tab
							eventKey="details"
							title={translation("userAccount.accountDetails")}
						>
							<ContentBody>
								<Row className="mt-4">
									<Col
										sm={12}
										md={6}
									>
										<CardAccountDetail user={user} />
									</Col>
									<Col
										sm={12}
										md={6}
										className="mt-sm-4 mt-md-0"
									>
										<CardAccessDetail user={user} />
									</Col>
								</Row>
								<Row className="mt-4">
									<Col>
										<CardCompanyDetail user={user} />
									</Col>
								</Row>
								<Row className="my-4">
									<Col>
										<CardSignatureDetail
											user={user}
											setUser={setUser}
										/>
									</Col>
								</Row>
							</ContentBody>
						</Tab>

						{/* Materiais utilizados */}
						<Tab
							eventKey="materials"
							title={
								user.status === "Assinante"
									? translation("userAccount.usedMaterials")
									: user.status === "Parceiro"
									? translation(
											"userAccount.registeredMaterials"
									  )
									: translation("userAccount.viewedMaterials")
							}
						>
							<UserMaterials
								userId={id}
								userType={userType}
							/>
						</Tab>
					</Tabs>
				</div>
			)}
		</Container>
	);
};
